import React from "react";
import { useTranslation } from "react-i18next";
import SeoHead from "../seo/SeoHead";
import ServicePage, { RelatedServices, ServiceChecklist, ServiceCta, ServiceFaq, ServiceHero } from "./ServicePageLayout";
import ProfPrice from "../../assets/prof-price.jpg";

const VehicleAppraisalsForBanks = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    const lang = i18n.language === 'en' ? 'en' : 'ar';
    const faq = t('vehicleAppraisalsFaq', { returnObjects: true });
    const points = [
        t('comprehensiveAssessment'),
        t('marketValueAnalysis'),
        t('conditionHistoryReports'),
        t('loanToValueCalculations'),
        t('vehicleAppraisalsPoint5'),
        t('vehicleAppraisalsPoint6'),
    ];

    return (
        <ServicePage isRTL={isRTL}>
            <SeoHead
                path="services/vehicle-appraisals-for-banks"
                title={t('vehicleAppraisalsMetaTitle')}
                description={t('vehicleAppraisalsMetaDescription')}
                keywords={t('vehicleAppraisalsMetaKeywords')}
                jsonLd={{
                    '@context': 'https://schema.org',
                    '@type': 'FAQPage',
                    mainEntity: faq.map(({ q, a }) => ({
                        '@type': 'Question',
                        name: q,
                        acceptedAnswer: { '@type': 'Answer', text: a },
                    })),
                }}
            />

            <ServiceHero
                eyebrow={t('vehicleAppraisalsEyebrow')}
                title={t('vehicleAppraisalsTitle')}
                intro={t('vehicleAppraisalsDescription').replace(/<\/?strong>/g, '')}
                image={ProfPrice}
                imageAlt={t('vehicleAppraisalsTitle')}
                ctaLabel={t('vehicleAppraisalsCtaLabel')}
                ctaMessage={isRTL ? 'مرحباً، أرغب في طلب تقييم مركبة للبنك.' : 'Hi, I would like to request a vehicle appraisal for a bank.'}
            />

            <ServiceChecklist title={t('vehicleAppraisalsIncludesTitle')} points={points} />
            <ServiceFaq title={t('vehicleAppraisalsFaqTitle')} items={faq} />
            <RelatedServices title={t('vehicleAppraisalsRelatedTitle')} items={t('vehicleAppraisalsRelatedItems', { returnObjects: true })} lang={lang} />

            <ServiceCta
                eyebrow={t('vehicleAppraisalsEyebrow')}
                title={t('vehicleAppraisalsTitle')}
                body={t('vehicleAppraisalsMetaDescription')}
                ctaLabel={t('vehicleAppraisalsCtaLabel')}
                ctaMessage={isRTL ? 'مرحباً، أرغب في طلب تقييم مركبة للبنك.' : 'Hi, I would like to request a vehicle appraisal for a bank.'}
            />
        </ServicePage>
    );
};

export default VehicleAppraisalsForBanks;
